import React from 'react';
import { DateTimeInput, Filter, SelectInput, useTranslate } from 'react-admin';

import { useEnumSelectChoices } from 'components/_helpers/useEnumSelectChoices';
import { AdminActionName } from 'entities/AdminActionName';


export const AdminActionsFilter = (props) => {
	const t = useTranslate();
	const adminActionChoices = useEnumSelectChoices(AdminActionName, '', false);

	return (
		<Filter {...props}>
			<SelectInput source='name' choices={adminActionChoices} />
			<DateTimeInput source="created_at:gte" label={t("osfc.filters.created_at.from")} withLocalTimeZone />
			<DateTimeInput source="created_at:lte" label={t("osfc.filters.created_at.to")} withLocalTimeZone />
		</Filter>
	);
};
